import { createAction } from "typesafe-actions";
import { TeaserActionTypes } from "./teaser-types";
import { TeaserState, TeaserParams } from "./teaser-reducer";

export interface TeaserRequest extends TeaserParams {
    apiUrl: string;
}

export interface TeaserResponse
    extends Pick<TeaserState, "teaserList" | "displayedTeasersOutOfTotalLabel" | "teasersTotalCount">,
        Pick<TeaserParams, "page"> {}

export interface PopulateTeasers extends Pick<TeaserState, "teaserList"> {}

export const teaserRequest = createAction(
    TeaserActionTypes.LOAD_MORE_REQUEST,
    action => (payload: TeaserRequest) => action(payload)
);

export const teaserSuccess = createAction(
    TeaserActionTypes.LOAD_MORE_SUCCESS,
    action => (payload: TeaserResponse) => action(payload)
);
export const teaserError = createAction(TeaserActionTypes.LOAD_MORE_ERROR);

export const populateTeasers = createAction(
    TeaserActionTypes.POPULATE_TEASERS,
    action => (payload: PopulateTeasers) => action(payload)
);

export const updateTeaserParams = createAction(
    TeaserActionTypes.UPDATE_TEASER_PARAMS,
    action => (payload: TeaserParams) => action(payload)
);
